<template>
    <div>
      <!--    <card-seplag class="card-seplag" titulo='Opções'>
           <div class="p-grid p-fluid menu-container">
                <div class="menu-div p-col-6 p-md-2"> 
                    <Button label="Ver Ciclos Criados" v-if="this.$store.state.paginaGerencia == 'gerenciaCiclo'"
                        class="p-button-rounded" /> 
                    <Button label="Ver Ciclos Criados" class="p-button-secondary p-button-rounded" @click="irPara()" />
                </div>

                <div class="menu-div p-col-6 p-md-2">
                    <Button label="Criar Ciclo" v-if="this.$store.state.paginaGerencia == 'gerenciaCiclo'"
                        class="p-button-rounded" />
                    <Button label="Criar Ciclo" v-else class="p-button-secondary p-button-rounded"
                        @click="carregarPagina('gerenciaCiclo')" />
                </div> 
            
                <div class="menu-div p-col-6 p-md-2">
                    <Button label="Ciclo" v-if="this.$store.state.paginaGerencia=='gerenciaCiclo'" class="p-button-rounded" />
                    <Button label="Ciclo" v-else class="p-button-secondary p-button-rounded" @click="carregarPagina('gerenciaCiclo')"/>
                </div>  

                <div class="menu-div p-col-6 p-md-2">
                    <Button label="Etapas" v-if="this.$store.state.paginaGerencia=='etapasCiclo'" class="p-button-rounded"/>
                    <Button label="Etapas" v-else class="p-button-secondary p-button-rounded"  @click="carregarPagina('etapasCiclo')" :disabled="true"/>
                </div>

                <div class="menu-div p-col-6 p-md-2">
                    <Button label="Textos"  class="p-button-secondary p-button-rounded" @click="carregarPagina()" :disabled="true" />
                </div>
            </div> 
        </card-seplag> -->
        <card-seplag class="card-seplag" :titulo="titulo">
            <TabPanelGerencia :data="registro" v-if="this.$store.state.paginaGerencia == 'gerenciaCiclo'" />
            <TabPanelEtapas :data="registro" v-if="this.$store.state.paginaGerencia == 'etapasCiclo'" />
        </card-seplag>
    </div>
</template>
<script>
import CardSeplag from '@/template/CardSeplag.vue'
// import { baseApiUrl } from '@/config/global'
import TabPanelGerencia from '@/paginas/gerenciaCiclo/gerenciaCiclo.vue'
import TabPanelEtapas from '@/paginas/gerenciaCiclo/etapasCiclo.vue'
export default {
    name: 'ciclo-container',
    components: { CardSeplag, TabPanelGerencia, TabPanelEtapas },

    data: function () {
        return {
            titulo: '',
            registro: null,
        }
    },
    methods: {
        irPara() {
            this.$router.push('/' + process.env.VUE_APP_BASE_URL + '/ciclos')
        },
        carregarDados() {
            this.carregarPagina(this.$store.state.paginaGerencia)
        },
        carregarPagina(nomePagina) {
            if (nomePagina == "gerenciaCiclo") {
                this.titulo = "Ciclo"
                this.$store.commit("setPaginaGerencia", nomePagina)
            } else if (nomePagina == "etapasCiclo") {
                this.titulo = "Etapas"
                this.$store.commit("setPaginaGerencia", nomePagina)
            }
            else if (nomePagina == "empregado-perfil")
                this.titulo = "Perfil de acesso"
            this.$store.commit("setPaginaGerencia", nomePagina)

        },

    },
    mounted() {
        this.carregarDados()
    }
}
</script>

<style scoped>
.menu-container {
    width: 100%;
    text-align: center;
}

@media screen and (max-width:48rem) {
    .menu-div button {
        height: 66px !important;
        height: 86px;
        font-size: 15px !important;
    }
}

.menu-div button {
    height: 50px;
    font-size: 14px;
    font-weight: 600;
}
</style>